import { types } from "../types/types";


export const showSnackbar = (message) => ({
  type: types.SHOW_SNACKBAR,
  payload: message,
});

export const hideSnackbar = () => ({
  type: types.HIDE_SNACKBAR,
});

// Snackbar especial para Templates (si lo necesitas)
export const showTemplateSnackbar = (message, severity = 'info') => ({
  type: types.SHOW_TEMPLATE_SNACKBAR,
  payload: { message, severity },
});

export const hideTemplateSnackbar = () => ({
  type: types.HIDE_SHOW_TEMPLATE_SNACKBAR,
});

export const showContactAssignedSnackbar = (contact) => ({
  type: types.SHOW_CONTACT_ASSIGNED_SNACKBAR,
  payload: contact,
});

export const hideContactAssignedSnackbar = () => ({
  type: types.HIDE_CONTACT_ASSIGNED_SNACKBAR,
});

export const showReportReadySnackbar = (report) => ({
  type: types.SHOW_REPORT_READY_SNACKBAR,
  payload: report,
});

export const hideReportReadySnackbar = () => ({
  type: types.HIDE_REPORT_READY_SNACKBAR,
});